import { is } from "date-fns/locale"

export const VENDOR_STATUS_ACTIVE = "Active"
export const VENDOR_STATUS_INFO_INCOMPLETE = "Info Incomplete"
export const VENDOR_STATUS_RENEWAL_NEEDED = "Renewal Needed"
export const VENDOR_STATUS_INVITE_PENDING = "Invite Pending"
export const VENDOR_STATUS_INACTIVE = "Inactive"
export const VENDOR_STATUS_SUSPENDED = "Suspended"

export const VENDOR_STATUSES = {
    [VENDOR_STATUS_ACTIVE]: {
        primaryColor: "#148451",
        secondaryColor: "#D4F3E5"
    },
    [VENDOR_STATUS_RENEWAL_NEEDED]: {
        primaryColor: "#1D76B9",
        secondaryColor: "#BFE3FF"
    },
    [VENDOR_STATUS_INVITE_PENDING]: {
        primaryColor: "#C8841E",
        secondaryColor: "#FFEACB"
    }, 
    [VENDOR_STATUS_INACTIVE]: {
        primaryColor: "#C8841E",
        secondaryColor: "#FFEACB"
    },
    [VENDOR_STATUS_INFO_INCOMPLETE]: {
        primaryColor: "#C8841E",
        secondaryColor: "#FFEACB"
    },
    [VENDOR_STATUS_SUSPENDED]: null,
    "Blocked by Tipalti": null
}

export const PURCHASE_ORDER_STATUS_PENDING = "Pending"
export const PURCHASE_ORDER_STATUS_APPROVED = "Approved"
export const PURCHASE_ORDER_STATUS_REJECTED = "Rejected"
export const PURCHASE_ORDER_STATUSES = {
    [PURCHASE_ORDER_STATUS_PENDING]: {
        primaryColor: "#C8841E",
        secondaryColor: "#FFEACB"
    },
    [PURCHASE_ORDER_STATUS_APPROVED]: {
        primaryColor: "#148451",
        secondaryColor: "#D4F3E5"
    },
    [PURCHASE_ORDER_STATUS_REJECTED]: {
        primaryColor: "#B00020",
        secondaryColor: "#FFCDD2"
    }
}

export const BUSINESS_TYPES = ["Individual", "Company"]
export const PRODUCTION_TYPES = ["Freelance", "Agency"]
export const ACCOUNT_TYPES = ["Checking", "Savings"]
export const TAX_ID_TYPES = {USD: ["EIN", "SSN", "Other"], CAD: ["BN", "SIN"]}
export const TAX_FORM_TYPES = {USD: ["W-9", "W-8BEN", "W-8BEN-E", "Other"]}

export const XODO_TEMPLATE_NDA_UNILATERAL_CA = "NDA Unilateral (CAN)"
export const XODO_TEMPLATE_NDA_UNILATERAL_US = "NDA Unilateral (US)"
export const XODO_TEMPLATE_NDA_UNILATERAL_EU = "NDA Unilateral (EU)"
export const XODO_TEMPLATE_NDA_MUTUAL_CA = "NDA Mutual (CAN)"
export const XODO_TEMPLATE_NDA_MUTUAL_US = "NDA Mutual (US)"
export const XODO_TEMPLATE_NDA_MUTUAL_EU = "NDA Mutual (EU)"
export const XODO_TEMPLATE_VENDOR_AGREEMENT_US = "US Vendor Agreement"
export const XODO_TEMPLATE_VENDOR_AGREEMENT_US_INSURANCE_STRIKED = "US Vendor Agreement w/ Insurance Striked"
export const XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_CONTENT = "CAN Vendor Agreement - Content"
export const XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_ALL_TERMS = "CAN Vendor Agreement - All Terms"
export const XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_DIGITAL = "CAN Vendor Agreement - Digital"
export const XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_CONTENT_TALENT = "CAN Vendor Agreement - Content - Talent"
export const XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_CONTENT_INSURANCE_STRIKED = "CAN Vendor Agreement - Content w/ Insurance Striked"
export const XODO_TEMPLATES = [
    XODO_TEMPLATE_NDA_UNILATERAL_CA,
    XODO_TEMPLATE_NDA_UNILATERAL_US,
    XODO_TEMPLATE_NDA_UNILATERAL_EU,
    XODO_TEMPLATE_NDA_MUTUAL_CA,
    XODO_TEMPLATE_NDA_MUTUAL_US,
    XODO_TEMPLATE_NDA_MUTUAL_EU,
    XODO_TEMPLATE_VENDOR_AGREEMENT_US,
    XODO_TEMPLATE_VENDOR_AGREEMENT_US_INSURANCE_STRIKED,
    XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_CONTENT,
    XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_ALL_TERMS,
    XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_DIGITAL,
    XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_CONTENT_TALENT,
    XODO_TEMPLATE_VENDOR_AGREEMENT_CAN_CONTENT_INSURANCE_STRIKED
]

export const XODO_DOCUMENTS_BASE_URL = "https://makerssign.eversign.com/documents/"

export const VENDOR_PAYMENT_METHOD_ACH = "ACH"
export const VENDOR_PAYMENT_METHOD_WIRE = "Wire Transfer"
export const VENDOR_PAYMENT_METHODS = [
    VENDOR_PAYMENT_METHOD_ACH,
    VENDOR_PAYMENT_METHOD_WIRE
]

export const VENDOR_FIELDS_SETS = {
    ACHCA: ["institution_number", "branch_routing_number", "account_type"],
    ACHUS: ["aba_number", "account_type"],
    Wire: ["institution_number", "branch_routing_number", "swift_code"],
}

export const getFieldsSet = (payment_method, legal_entity_currency) => {
    const isACHCA = payment_method == VENDOR_PAYMENT_METHOD_ACH && legal_entity_currency == "CAD"
    const isACHUS = payment_method == VENDOR_PAYMENT_METHOD_ACH && legal_entity_currency == "USD"
    const isWire = payment_method == VENDOR_PAYMENT_METHOD_WIRE

    if (isACHCA) {
        return VENDOR_FIELDS_SETS.ACHCA
    } else if (isACHUS) {
        return VENDOR_FIELDS_SETS.ACHUS
    } else if (isWire) {
        return VENDOR_FIELDS_SETS.Wire
    }
    return VENDOR_FIELDS_SETS.Wire
}